import lightbox from 'lightbox2'
export default {
  init() {
    // JavaScript to be fired on the single accommodation page
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
    })

    $('.read_more').readmore({
      speed: 1000,
      collapsedHeight: 380,
      heightMargin: 30,
      moreLink: '<span class="btn btn-secondary read-more-btn" href="#">Read More</span>',
      lessLink: '<span class="btn btn-secondary read-more-btn" href="#">Read less</span>',
    })

    $('.display_more').readmore({
      speed: 1000,
      moreLink: '<span class="btn btn-secondary read-more-btn" href="#">Display More</span>',
      lessLink: '<span class="btn btn-secondary read-more-btn" href="#">Display less</span>',
    })

    // $('.accomm-room-gallery').slick({
    //   dots: true,
    //   infinite: true,
    //   speed: 300,
    //   slidesToShow: 1,
    //   adaptiveHeight: true,
    // })

    if(jQuery('.room-slider').length) {

      jQuery('.room-slider').each(function(){

        var $this = jQuery(this);
        var $parent = jQuery(this).parent();
        var $status = jQuery($parent).find('.room-slider-meta .count');

        $this.on('init reInit afterChange', function (event, slick, currentSlide) {
          var i = (currentSlide ? currentSlide : 0) + 1;
          $status.text(i + '/' + slick.slideCount);
        });

        $this.slick({
          centerMode: true,
          autoplay: true,
          dots: false,
          arrows: false,
          slidesToShow: 3,
          autoplaySpeed: 4000,
          responsive: [
            {
              breakpoint: 780,
              settings: {
                slidesToShow: 2,
                centerMode: false,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                centerMode: false,
              },
            },
          ],
        });

        // disable center mode if less than 3 slides
        var $slides = $this.find('.single-room-wrap').length;
        if($slides < 4){
          $this.slick('slickSetOption', 'centerMode', false);
          $this.addClass('centerFalse');
          jQuery($parent).find('.room-slider-meta').hide();
        }

        jQuery($parent).find('.room-slider-meta .prev').click(function() {
          jQuery($this).slick('slickPrev');
        });
        jQuery($parent).find('.room-slider-meta .next').click(function() {
          jQuery($this).slick('slickNext');
        });

      });

    }


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-accommodation.js